import React from "react";
import ProductComingSoonLanding from "./ProductComingSoonLanding.jsx";

const HERO_TAGS = ["New build", "Conversion", "Refinance development"];

const FEATURE_CARDS = [
  {
    title: "Scheme economics in one view",
    description:
      "Bring together land or purchase costs, build spend, professional fees, and target end values to size the facility.",
  },
  {
    title: "Staged funding awareness",
    description:
      "Preview how loan-to-cost and loan-to-GDV limits influence drawdowns as the project hits milestones.",
  },
  {
    title: "Shortlist & apply in one journey",
    description:
      "When live, compare development facilities and continue to lender application with shared project data.",
  },
];

const STEPS = [
  {
    title: "Capture the development scheme",
    body: "Costs, timelines, planning status, and sales strategy tell lenders how much risk they’re taking.",
  },
  {
    title: "Compare facility structures",
    body: "Review indicative interest, fees, equity requirement, and leverage across development lenders.",
  },
  {
    title: "Shortlist and apply",
    body: "Save development options to revisit once calculator and sourcing tools are connected.",
  },
];

const CRITERIA_CHIPS = [
  "Gross development value (GDV)",
  "Total build & site costs",
  "Loan to cost / loan to GDV",
  "Developer track record",
  "Planning status",
  "Main contractor / procurement",
  "Drawdown schedule",
  "Contingency & professional fees",
  "Pre-sales / exit strategy",
];

export default function DevelopmentCalculator() {
  return (
    <ProductComingSoonLanding
      productLabel="Development"
      heroTitle="Development Finance Calculator"
      heroDescription="Fund residential or mixed schemes with lender-led leverage and cost modelling. Coming soon."
      heroSrc="/Development.webp"
      primaryCtaText="Source development finance (Coming soon)"
      heroTags={HERO_TAGS}
      introTitle="Development finance calculator (Coming soon)"
      introBody="Development finance depends on GDV, costs, and your delivery track record. Dynesourcer will help borrowers sanity-check leverage and fees before speaking to lenders—this route is the preview."
      featureCards={FEATURE_CARDS}
      howItWorksTitle="How development finance will work on Dynesourcer"
      howItWorksIntro="You document the scheme; we match development lenders whose leverage bands and sectors align."
      steps={STEPS}
      criteriaTitle="Typical development criteria (preview)"
      criteriaIntro="Lenders stress GDV, cost control, and experience. Below are representative matching dimensions."
      criteriaChips={CRITERIA_CHIPS}
      ctaTitle="Running a development project?"
      ctaDescription="See how Dynesourcer supports borrowers end-to-end. Full development calculators land here at launch."
      ctaPrimary={{ to: "/explore-borrower-journey", label: "Explore borrower journey" }}
      ctaSecondary={{ to: "/sourcing/buy-to-let-mortgage-sourcing", label: "Try BTL sourcing today" }}
    />
  );
}
